import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import axios from 'axios';
// GTM
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
// Structure
import PikiLoader from './vendor/PikiLoader/PikiLoader';
import Navigation from './scripts/helpers/Navigation';
import Header from './scripts/structure/Header';
import Footer from './scripts/structure/Footer';
// Home
import Home from './scripts/pages/Home';
import Planos from './scripts/pages/Planos';
// Planos
import Plano from './scripts/pages/Plano';
// Common
import AdesaoDigital from './scripts/pages/AdesaoDigital'
import SimuladorBeneficios from './scripts/pages/SimuladorBeneficios';
import MarchaDosPrefeitos from './scripts/pages/MarchaDosPrefeitos'
import FaleConosco from './scripts/pages/FaleConosco';
import Comunicados from './scripts/pages/Comunicados';
import ClubeDeBeneficios from './scripts/pages/ClubeDeBeneficios';
import BlogBBP from './scripts/pages/BlogBBP';
import BlogBBPCateg from './scripts/pages/BlogBBPCateg';
import BlogBBPSingle from './scripts/pages/BlogBBPSingle';
import Documentos from './scripts/pages/Documentos';
import DemonstrativosFormularios from './scripts/pages/DemonstrativosFormularios';
import PerguntasFrequentes from './scripts/pages/PerguntasFrequentes';
import Glossario from './scripts/pages/Glossario';
import HomeSeguranca from './scripts/pages/HomeSeguranca';
import SingleSeguranca from './scripts/pages/SingleSeguranca';
import ArquivosSeguranca from './scripts/pages/ArquivosSeguranca';
import Page from './scripts/pages/Page';
import NotFound from './scripts/pages/NotFound';

const API_URL = process.env.REACT_APP_API_URL;

// Analytics agora usa useLocation diretamente
function Analytics() {
    const location = useLocation();
    const defaultGTM = 'G-GRB9XZ6ZG5';

    useEffect(() => {
        setTimeout(() => {
            let _g4_title = 'BB Previdência';

            const pageTitle = document.querySelector('.page-title');
            if (pageTitle) {
                _g4_title += (' | ' + pageTitle.innerText);
            }

            const innerTitle = document.querySelector('article h2:not(.page-title)');
            if (innerTitle) {
                _g4_title += (' | ' + innerTitle.innerText);
            }

            ReactGA.initialize(defaultGTM);
            ReactGA.send({ hitType: "pageview", page: location.pathname, title: _g4_title });
        }, 1000);
    });

    return null;
}

function App() {

    const [basename, setBasename] = useState('/')
    const [isPlain, swithIsplain] = useState(null)
    const [siteData, setSiteData] = useState(null)
    const [singlePage, setSinglePage] = useState(null)

    const campains = [
        'aderiu-ganhou',
        'simulador-de-beneficio-fiscal',
        'bbprevbrasil-marchadosprefeitos'
    ];

    useEffect(() => {

        const lastPeace = document.location.href.split('/').pop().split('?').shift().split('#').shift()
        if (campains.includes(lastPeace)) {

            const tagManagerArgs = { gtmId: 'GTM-P5P4QN2' };
            TagManager.initialize(tagManagerArgs);

            if (lastPeace === 'aderiu-ganhou') {
                setSinglePage('aderiu-ganhou')
            }
        }

        function receivePlans(planos) {
            window.planos = planos;
            window.isHome = true;
            window.siteID = false;
            window.isFrontPage = document.location.href.replace('https', '').replace('http', '') === process.env.REACT_APP_API_URL.replace('https', '').replace('http', '');

            let machedPlain = false;
            if (window.siteKey !== '') {
                planos.forEach(function (plano) {
                    if (plano.sitekey === window.siteKey) {
                        window.siteID = plano.id;
                        window.isHome = false;
                        machedPlain = plano.sitekey;
                    }
                });
            }

            swithIsplain(machedPlain !== false);
        }

        axios
            .get(API_URL + '/data/planos.json')
            .then(function (response) { receivePlans(response.data); })
            .catch(function (error) { console.log(error); })
        ;

    }, []);

    useEffect(() => {

        if (isPlain !== null) {

            let ENDPOINT = isPlain
                ? API_URL + '/data/' + window.siteKey + '/home.json'
                : API_URL + '/data/home.json';

            axios
                .get(ENDPOINT)
                .then((res) => {
                    window.siteID = res.data.id;
                    setBasename(isPlain ? window.siteKey : '/');
                    setSiteData(res.data);
                    closeLoader();
                })
                .catch((err) => {
                    console.log(err)
                    setSiteData(false);
                })
                .finally(() => { closeLoader(); })
            ;
        }

    }, [isPlain]);

    function closeLoader() {
        const Loader = document.getElementById('main-loader');
        if (Loader) {
            Loader.parentNode.removeChild(Loader);
        }
    }

    if (siteData === null) {
        return null;
    }
    else if (singlePage) {
        return <AdesaoDigital />
    }
    else if (siteData === false) {
        return (
            <Router>
                <Navigation />
                <Header siteData={false} />
                <NotFound siteID={false} />
            </Router>
        )
    }
    else {
        return (
            <HelmetProvider>
                <Router basename={basename}>
                    <PikiLoader />
                    <Navigation />
                    <Header siteData={siteData} />
                    <Routes>
                        <Route path="/simulador-de-beneficio-fiscal" element={<SimuladorBeneficios />} />
                        <Route path="/bbprevbrasil-marchadosprefeitos" element={<MarchaDosPrefeitos />} />
                        <Route path="/seguranca/artigo/:itemID" element={<SingleSeguranca />} />
                        <Route path="/seguranca/:itemID" element={<ArquivosSeguranca />} />
                        <Route path="/seguranca" element={<HomeSeguranca />} />
                        <Route path="/fale-conosco" element={<FaleConosco siteData={siteData} />} />
                        <Route path="/planos" element={<Planos />} />
                        <Route path="/comunicados/*" element={<Comunicados />} />
                        <Route path="/clube-de-beneficios" element={<ClubeDeBeneficios data={siteData} />} />
                        <Route path="/blogbbp/glossario" element={<Glossario />} />
                        <Route path="/blogbbp" element={<BlogBBP data={siteData.blogbbp} />} />
                        <Route path="/blogbbp/:category/:itemID" element={<BlogBBPSingle />} />
                        <Route path="/blogbbp/:category" element={<BlogBBPCateg />} />
                        <Route path="/documentos" element={<Documentos />} />
                        <Route path="/demonstrativos-e-formularios/:groupID" element={<DemonstrativosFormularios />} />
                        <Route path="/demonstrativos-e-formularios" element={<DemonstrativosFormularios />} />
                        <Route path="/perguntas-frequentes" element={<PerguntasFrequentes siteData={siteData} />} />
                        <Route path="/" element={window.isHome ? <Home siteData={siteData} /> : <Plano siteData={siteData} />} />
                        <Route path="*" element={<Page siteID={siteData.id} />} />
                    </Routes>
                    <Footer siteData={siteData} />
                    <Analytics />
                </Router>
            </HelmetProvider>
        )
    }
}

export default App;